document.addEventListener("DOMContentLoaded", function() {
  // Check cart total after page loads
  checkCartTotal();

  // Listen for cart updates
  document.addEventListener('cart:updated', function() {
    checkCartTotal();
  });

  function checkCartTotal() {
    // Shopify's AJAX API to get the cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const total = cart.total_price / 100; // Convert from cents to dollars
        if (total >= 99 && !localStorage.getItem('popupShown')) {
          // Show the popup if the cart total is above $99
          document.getElementById('cartPopup').style.display = 'flex';
          localStorage.setItem('popupShown', 'true'); // Prevent it from showing again
        }
      });
  }
});
